import { createSelector } from 'reselect';
import { relatedSearchesSelector } from 'selectors/testTarget/offers/relatedSearches/relatedSearchesSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { RELATED_SEARCHES_EXPERIENCE } from 'constants/TestTarget';

const KNOWN_VARIANTS = Object.values(RELATED_SEARCHES_EXPERIENCE);

// Variant resolution: reads the offer selector DIRECTLY (no experienceSelector passthrough),
// gated on TestTarget readiness. Pending => undefined; unknown/missing => Control (AC-015/AC-028).
const relatedSearchesVariantSelector = createSelector(isTestTargetReadySelector, relatedSearchesSelector, (isReady, offer) => {
    if (!isReady) {
        return undefined;
    }

    const { experience } = offer;

    // SBR-3535 ANALYTICS HOOK: emit fallback_reason here when resolving unknown/missing => Control (out of scope this bundle).
    return KNOWN_VARIANTS.includes(experience) ? experience : RELATED_SEARCHES_EXPERIENCE.CONTROL;
});

export { relatedSearchesVariantSelector };
